<template>
  <div class="register-page">
    <!-- DESKTOP SIDEBAR -->
    <div class="reg-container">
      <RegisterSidebar
        :steps="steps"
        :active-step="activeStep"
        class="desktop-only"
      >
      </RegisterSidebar>
    </div>

    <!-- MAIN CONTENT -->
    <main class="content">
      <span class="logo">
        <img src="../assets/images/logo-perindo-new.png" alt="logo"/>
      </span>
      <template v-if="activeStep < steps.length - 1">
        <a class="mobile-back mobile-only" @click="$router.push('/dashboard')">
          <span>
            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 12L0 6L6 0L7.4 1.4L2.8 6L7.4 10.6L6 12Z" fill="#182773"/>
            </svg>
          </span>
          Kembali ke Dashboard
        </a>

        <BenefitAccordion
          v-if="activeStep === 0"
          :show="activeStep === 0"
          :defaultOpen="[]"
          class="mobile-only"
        />

        <h2>Unggah Foto KTP Kamu</h2>
        <p class="subtitle">
          Gunakan KTP aslimu. Pastikan foto KTP jelas dan tidak buram
        </p>

        <UploadField v-model="ktpFile" @update:modelValue="handleKtpUpload">
          <template #icon>
            <!-- SVG icon upload -->
          </template>
        </UploadField>

        <template v-if="ktpFile">
          <div class="form-registrasi">
            <div class="form-input">
              <FieldInput
                v-model="form.nik"
                label="NIK"
                required
                placeholder="16 digit no KTP"
                :state="nikState"
                :message="nikMessage"
                :maxlength="16"
                type="numeric"
              />
              <FieldInput
                v-model="form.nama_lengkap"
                label="Nama Lengkap"
                required
                placeholder="Masukkan nama sesuai KTP"
              />
              <FieldInput
                v-model="form.tempat_lahir"
                label="Tempat Lahir"
                required
                placeholder="Masukkan tempat lahir sesuai KTP"
              />
              <FieldDate
                v-model="form.tanggal_lahir"
                label="Tanggal Lahir"
                required
                placeholder="DD/MM/YYYY"
                :state="dobState"
                :message="dobMessage"
              />
              <FieldSelect
                v-model="form.jenis_kelamin"
                label="Jenis Kelamin"
                placeholder="Pilih jenis kelamin"
                :options="jenisKelaminList"
                label-key="label"
                value-key="value"
                :searchable="false"
                required
              />
              <FieldSelect
                v-model="form.status_id"
                label="Status"
                placeholder="Pilih status sesuai KTP"
                :options="statusList"
                label-key="status_name"
                value-key="status_id"
                :searchable="false"
                required
              />
              <FieldSelect
                v-model="form.job_id"
                label="Pekerjaan"
                placeholder="Pilih pekerjaan sesuai KTP"
                :options="jobList"
                label-key="job_name"
                value-key="job_id"
                :searchable="false"
                required
              />
            </div>

            <div class="divider" />
            <p class="form-title">Informasi Alamat KTP</p>

            <FieldInput
              v-model="form.alamat_ktp"
              label="Alamat Lengkap"
              required
              placeholder="Masukkan alamat sesuai KTP"
            />

            <div class="form-input">
              <FieldSelect
                v-model="form.prov_id"
                label="Provinsi"
                placeholder="Pilih Provinsi"
                :options="provinceList"
                label-key="prov_name"
                value-key="prov_id"
                required
                @update:modelValue="onProvinceChange"
              />
              <FieldSelect
                v-model="form.kab_id"
                label="Kabupaten/Kota"
                placeholder="Pilih Kabupaten/Kota"
                :options="kabList"
                label-key="kab_name"
                value-key="kab_id"
                required
                :disabled="!form.prov_id"
                @update:modelValue="onKabupatenChange"
              />
              <FieldSelect
                v-model="form.kec_id"
                label="Kecamatan"
                placeholder="Pilih Kecamatan"
                :options="kecList"
                label-key="kec_name"
                value-key="kec_id"
                required
                :disabled="!form.kab_id"
                @update:modelValue="onKecamatanChange"
              />
              <FieldSelect
                v-model="form.kel_id"
                label="Kelurahan"
                placeholder="Pilih Kelurahan"
                :options="kelList"
                label-key="kel_name"
                value-key="kel_id"
                required
                :disabled="!form.kec_id"
              />
              <FieldInput
                v-model="form.post_code"
                label="Kode Pos"
                required
                placeholder="Masukkan Kode Pos"
                type="numeric"
                :maxlength="5"
              />
            </div>

            <div class="divider" />
            <p class="form-title">Alamat Domisili</p>
            <BaseCheckbox v-model="form.same_address_domisili" @update:modelValue="handleSameAddress">
              Alamat domisili sama dengan alamat KTP
            </BaseCheckbox>

            <div class="domisili" v-if="!form.same_address_domisili">
              <FieldInput
                v-model="form.alamat_domisili"
                label="Alamat Lengkap"
                required
                placeholder="Masukkan alamat domisili"
              />
              <div class="form-input">
                <FieldSelect
                  v-model="form.prov_id_domisili"
                  label="Provinsi"
                  placeholder="Pilih Provinsi"
                  :options="provinceList"
                  label-key="prov_name"
                  value-key="prov_id"
                  required
                  @update:modelValue="onProvinceDomisiliChange"
                />
                <FieldSelect
                  v-model="form.kab_id_domisili"
                  label="Kabupaten/Kota"
                  placeholder="Pilih Kabupaten/Kota"
                  :options="kabListDomisili"
                  label-key="kab_name"
                  value-key="kab_id"
                  required
                  :disabled="!form.prov_id_domisili"
                  @update:modelValue="onKabupatenDomisiliChange"
                />
                <FieldSelect
                  v-model="form.kec_id_domisili"
                  label="Kecamatan"
                  placeholder="Pilih Kecamatan"
                  :options="kecListDomisili"
                  label-key="kec_name"
                  value-key="kec_id"
                  required
                  :disabled="!form.kab_id_domisili"
                  @update:modelValue="onKecamatanDomisiliChange"
                />
                <FieldSelect
                  v-model="form.kel_id_domisili"
                  label="Kelurahan"
                  placeholder="Pilih Kelurahan"
                  :options="kelListDomisili"
                  label-key="kel_name"
                  value-key="kel_id"
                  required
                  :disabled="!form.kec_id_domisili"
                />
                <FieldInput
                  v-model="form.kode_pos_domisili"
                  label="Kode Pos"
                  required
                  placeholder="Masukkan Kode Pos"
                  type="numeric"
                  :maxlength="5"
                />
              </div>
            </div>

            <div class="divider" />
            <p class="form-title">Informasi Lainnya</p>
            <div class="form-input">
              <FieldInput
                v-model="form.email"
                label="Email (Opsional)"
                placeholder="Masukkan alamat email"
                :state="emailState"
                :message="emailMessage"
              />
            </div>
            <div class="divider" style="margin-top: 8px; margin-bottom: 12px;" />
          </div>

          <div class="tc-desktop-only">
            <div style="display: flex; gap: 8px;">
              <BaseCheckbox v-model="perindo_tc" />
              <p>Saya menyetujui <a @click="onClickPerindoTc" class="terms">Syarat dan Ketentuan Perindo</a></p>
            </div>
            <div style="display: flex; gap: 8px;">
              <BaseCheckbox v-model="vision_tc" />
              <p>Saya menyetujui <a class="terms" @click="onClickVisionTc">Syarat dan Ketentuan Vision+</a></p>
            </div>
          </div>
        </template>

        <template v-if="activeStep === 0 && ktpFile">
          <div class="tc-mobile-only">
            <div style="display: flex; gap: 8px;">
              <BaseCheckbox v-model="perindo_tc" />
              <p>Saya menyetujui <a @click="onClickPerindoTc" class="terms">Syarat dan Ketentuan Perindo</a></p>
            </div>
            <div style="display: flex; gap: 8px;">
              <BaseCheckbox v-model="vision_tc" />
              <p>Saya menyetujui <a class="terms" @click="onClickVisionTc">Syarat dan Ketentuan Vision+</a></p>
            </div>
          </div>
        </template>

        <button class="next-btn" :disabled="!isFormValid || isLoad" @click="daftarMember">
          <span v-if="isLoad" class="loader-container">
            <span class="loader"></span>
            <span>Memproses...</span>
          </span>
          <span v-else>Daftar</span>
        </button>
      </template>

      <template v-else>
        <RegisterComplete
          title="Selamat, kamu sudah menjadi bagian dari energi baru Indonesia"
          description="KTA kamu sudah berhasil dibuat. Sekarang kamu adalah anggota resmi Partai Perindo."
          @action="$router.push('/dashboard')"
        />
      </template>
    </main>
  </div>
  <KtpPreviewModal
    :show="showKtpModal"
    :file="tempFile"
    @close="handleRetry"
    @retry="handleRetry"
    @use="handleUseFile"
  />
</template>

<script>
import axios from 'axios'
import RegisterSidebar from '@/components/RegisterSidebar.vue'
import UploadField from '@/components/UploadField.vue'
import FieldInput from '../components/FieldInput.vue'
import BaseCheckbox from '../components/BaseCheckbox.vue'
import FieldSelect from '../components/FieldSelect.vue'
import FieldDate from '../components/FieldDate.vue'
import RegisterComplete from '../components/RegisterComplete.vue'
import { stepIcons } from '../assets/icons/stepIcons.js'
import BenefitAccordion from '../components/BenefitAccordion.vue'
import KtpPreviewModal from '@/components/KtpPreviewModal.vue'

export default {
  components: {
    RegisterSidebar,
    UploadField,
    FieldInput,
    BaseCheckbox,
    FieldSelect,
    FieldDate,
    RegisterComplete,
    BenefitAccordion,
    KtpPreviewModal
  },
  data () {
    return {
      ktpFile: null,
      activeStep: 0,
      isLoad: false,

      showKtpModal: false,
      tempFile: null,

      // Master Data Lists
      provinceList: [],
      kabList: [],
      kecList: [],
      kelList: [],
      kabListDomisili: [],
      kecListDomisili: [],
      kelListDomisili: [],
      jobList: [],
      statusList: [],
      listpendidikan: [],
      jenisKelaminList: [
        { value: 'L', label: 'Laki-laki' },
        { value: 'P', label: 'Perempuan' }
      ],

      steps: [
        {
          id: 'ktp',
          label: 'Verifikasi Data KTP',
          iconInactive: stepIcons.dataInactive,
          iconActive: stepIcons.dataActive
        },
        {
          id: 'done',
          label: 'Selesai',
          iconInactive: stepIcons.doneInactive,
          iconActive: stepIcons.doneActive
        }
      ],

      vision_tc: true,
      perindo_tc: true,
      form: {
        nik: '',
        nama_lengkap: '',
        tempat_lahir: '',
        tanggal_lahir: null,
        jenis_kelamin: '',
        status_id: '',
        job_id: '',
        alamat_ktp: '',
        prov_id: '',
        kab_id: '',
        kec_id: '',
        kel_id: '',
        post_code: '',
        same_address_domisili: true,
        prov_id_domisili: '',
        kab_id_domisili: '',
        kec_id_domisili: '',
        kel_id_domisili: '',
        alamat_domisili: '',
        kode_pos_domisili: '',
        email: '',
        foto_ktp: null,
      },
    }
  },

  computed: {
    // NIK validation
    nikState () {
      if (!this.form.nik) return 'default'
      return this.form.nik.length === 16 ? 'default' : 'error'
    },
    nikMessage () {
      if (!this.form.nik) return ''
      return this.form.nik.length === 16 ? '' : 'NIK harus 16 digit'
    },

    // Age validation
    dobState () {
      if (!this.form.tanggal_lahir) return 'default'
      if (!this.isValidDDMMYYYY(this.form.tanggal_lahir)) return 'error'
      const age = this.getAgeFromDDMMYYYY(this.form.tanggal_lahir)
      return age >= 17 ? 'default' : 'error'
    },
    dobMessage () {
      if (!this.form.tanggal_lahir) return ''
      if (!this.isValidDDMMYYYY(this.form.tanggal_lahir)) return 'Format tanggal harus DD/MM/YYYY'
      const age = this.getAgeFromDDMMYYYY(this.form.tanggal_lahir)
      return age >= 17 ? '' : 'Umur minimal 17 tahun'
    },

    // Email validation
    emailState () {
      if (!this.form.email) return 'default'
      return this.isValidEmail(this.form.email) ? 'default' : 'error'
    },
    emailMessage () {
      if (!this.form.email) return ''
      return this.isValidEmail(this.form.email) ? '' : 'Format email tidak valid'
    },

    // Form validation
    isFormValid () {
      // Validasi KTP dan foto
      if (!this.ktpFile) return false

      // Validasi data pribadi
      if (!this.form.nik || this.nikState !== 'default') return false
      if (!this.form.nama_lengkap || this.form.nama_lengkap.trim() === '') return false
      if (!this.form.tempat_lahir || this.form.tempat_lahir.trim() === '') return false
      if (!this.form.tanggal_lahir || this.dobState !== 'default') return false
      if (!this.form.jenis_kelamin) return false
      if (this.emailState !== 'default') return false

      // Validasi alamat KTP
      if (!this.form.alamat_ktp || this.form.alamat_ktp.trim() === '') return false
      if (!this.form.prov_id) return false
      if (!this.form.kab_id) return false
      if (!this.form.kec_id) return false
      if (!this.form.kel_id) return false
      if (!this.form.post_code || this.form.post_code.length < 5) return false

      // Validasi informasi lainnya
      if (!this.form.job_id) return false
      if (!this.form.status_id) return false

      // Validasi domisili HANYA jika alamat berbeda
      if (!this.form.same_address_domisili) {
        if (!this.form.alamat_domisili || this.form.alamat_domisili.trim() === '') return false
        if (!this.form.prov_id_domisili) return false
        if (!this.form.kab_id_domisili) return false
        if (!this.form.kec_id_domisili) return false
        if (!this.form.kel_id_domisili) return false
        if (!this.form.kode_pos_domisili || this.form.kode_pos_domisili.length < 5) return false
      }

      if (!this.vision_tc) return false
      if (!this.perindo_tc) return false

      return true
    },
  },

  methods: {
    onClickVisionTc () {
      window.open('https://supports.visionplus.id/vplus/help/article/terms-and-conditions', '_blank')
    },
    onClickPerindoTc () {
      window.open('https://partaiperindo.com/syarat-dan-ketentuan', '_blank')
    },
    // Handle KTP file upload
    handleKtpUpload(file) {
      if (!file) return

      const isPDF = file.type.includes('pdf')

      if (!isPDF) {
        // simpan sementara
        this.tempFile = file

        // buka modal
        this.showKtpModal = true

        return
      }

      // kalau PDF -> langsung set
      this.ktpFile = file
      this.form.foto_ktp = file
    },

    // Handle same address checkbox
    handleSameAddress (value) {
      if (value) {
        // Copy data KTP ke domisili
        this.form.alamat_domisili = this.form.alamat_ktp
        this.form.prov_id_domisili = this.form.prov_id
        this.form.kab_id_domisili = this.form.kab_id
        this.form.kec_id_domisili = this.form.kec_id
        this.form.kel_id_domisili = this.form.kel_id
        this.form.kode_pos_domisili = this.form.kode_pos

        // Load wilayah domisili
        if (this.form.prov_id_domisili) {
          this.getKabupaten(this.form.prov_id_domisili, true)
        }
        if (this.form.kab_id_domisili) {
          this.getKecamatan(this.form.kab_id_domisili, true)
        }
        if (this.form.kec_id_domisili) {
          this.getKelurahan(this.form.kec_id_domisili, true)
        }
      } else {
        // Reset domisili
        this.form.alamat_domisili = ''
        this.form.prov_id_domisili = ''
        this.form.kab_id_domisili = ''
        this.form.kec_id_domisili = ''
        this.form.kel_id_domisili = ''
        this.form.kode_pos_domisili = ''
        this.kabListDomisili = []
        this.kecListDomisili = []
        this.kelListDomisili = []
      }
    },

    handleUseFile(file) {
      this.ktpFile = file
      this.form.foto_ktp = file
      this.showKtpModal = false
      this.$store.commit('showGlobalAlert', {
        message: 'Lengkapi data sesuai KTP kamu',
      })
    },

    handleRetry() {
      this.tempFile = null
      this.showKtpModal = false
      this.ktpFile = null
    },

    // === WILAYAH KTP HANDLERS ===
    onProvinceChange (provId) {
      // Reset child dropdowns
      this.form.kab_id = ''
      this.form.kec_id = ''
      this.form.kel_id = ''
      this.kabList = []
      this.kecList = []
      this.kelList = []

      if (provId) {
        this.getKabupaten(provId, false)
      }
    },

    onKabupatenChange (kabId) {
      // Reset child dropdowns
      this.form.kec_id = ''
      this.form.kel_id = ''
      this.kecList = []
      this.kelList = []

      if (kabId) {
        this.getKecamatan(kabId, false)
      }
    },

    onKecamatanChange (kecId) {
      // Reset child dropdown
      this.form.kel_id = ''
      this.kelList = []

      if (kecId) {
        this.getKelurahan(kecId, false)
      }
    },

    // === WILAYAH DOMISILI HANDLERS ===
    onProvinceDomisiliChange (provId) {
      // Reset child dropdowns
      this.form.kab_id_domisili = ''
      this.form.kec_id_domisili = ''
      this.form.kel_id_domisili = ''
      this.kabListDomisili = []
      this.kecListDomisili = []
      this.kelListDomisili = []

      if (provId) {
        this.getKabupaten(provId, true)
      }
    },

    onKabupatenDomisiliChange (kabId) {
      // Reset child dropdowns
      this.form.kec_id_domisili = ''
      this.form.kel_id_domisili = ''
      this.kecListDomisili = []
      this.kelListDomisili = []

      if (kabId) {
        this.getKecamatan(kabId, true)
      }
    },

    onKecamatanDomisiliChange (kecId) {
      // Reset child dropdown
      this.form.kel_id_domisili = ''
      this.kelListDomisili = []

      if (kecId) {
        this.getKelurahan(kecId, true)
      }
    },

    // === API CALLS ===
    async selectProv () {
      try {
        const provList = await axios.get('member/listprovinsi')
        this.provinceList = provList.data || []
      } catch (err) {
        this.logger('Error loading provinces:', err)
      }
    },

    async getKabupaten (provId, domisili = false) {
      try {
        const kabList = await axios.get(`member/listkabupatenkota?prov_id=${provId}`)
        if (domisili) {
          this.kabListDomisili = kabList.data || []
        } else {
          this.kabList = kabList.data || []
        }
      } catch (err) {
        this.logger('Error loading kabupaten:', err)
      }
    },

    async getKecamatan (kabId, domisili = false) {
      try {
        const kecList = await axios.get(`member/listkecamatan?kab_id=${kabId}`)
        if (domisili) {
          this.kecListDomisili = kecList.data || []
        } else {
          this.kecList = kecList.data || []
        }
      } catch (err) {
        this.logger('Error loading kecamatan:', err)
      }
    },

    async getKelurahan (kecId, domisili = false) {
      try {
        const kelList = await axios.get(`member/listkelurahandesa?kec_id=${kecId}`)
        if (domisili) {
          this.kelListDomisili = kelList.data || []
        } else {
          this.kelList = kelList.data || []
        }
      } catch (err) {
        this.logger('Error loading kelurahan:', err)
      }
    },

    async getJobList () {
      try {
        const jobList = await axios.get('member/listjob')
        this.jobList = jobList.data || []
      } catch (err) {
        this.logger('Error loading job:', err)
      }
    },

    async listStatus () {
      try {
        const statusList = await axios.get('member/liststatus')
        this.statusList = statusList.data || []
      } catch (err) {
        this.logger('Error loading status:', err)
      }
    },

    // Form submission
    async daftarMember () {
      if (this.form.foto_ktp.size > 1000000) {
        this.alertFailed('Ukuran file harus di bawah 1MB')
        return
      }

      const data = new FormData()

      // Append all form data
      Object.keys(this.form).forEach(key => {
        if (this.form[key] !== null && this.form[key] !== '') {
          // Convert tanggal_lahir dari DD/MM/YYYY ke YYYY-MM-DD
          if (key === 'tanggal_lahir') {
            data.append(key, this.convertDateToISO(this.form[key]))
          } else {
            data.append(key, this.form[key])
          }
        }
      })

      try {
        this.isLoad = true
        const regMember = await axios.post('member/register-member', data)
        if (regMember.status === 201) {
          this.activeStep++
        }
      } catch (err) {
        if (err.response) {
          let msg = ''
          if(typeof err.response?.data === 'string') msg = err.response.data
          else msg = err.response.data?.message
          this.$store.commit('showGlobalAlert', {
            message: msg || 'Terjadi kesalahan',
            type: 'danger'
          })
        }
      } finally {
        this.isLoad = false
      }
    },

    convertDateToISO (dateStr) {
      if (!dateStr) return ''
      // Input: DD/MM/YYYY (18/02/1986)
      // Output: YYYY-MM-DD (1986-02-18)
      const [day, month, year] = dateStr.split('/')
      return `${year}-${month}-${day}`
    },

    // Validation helpers
    isValidDDMMYYYY (val) {
      if (!/^(\d{2})\/(\d{2})\/(\d{4})$/.test(val)) return false
      const [d, m, y] = val.split('/').map(Number)
      const date = new Date(y, m - 1, d)
      return date.getFullYear() === y && date.getMonth() === (m - 1) && date.getDate() === d
    },

    getAgeFromDDMMYYYY (val) {
      const [d, m, y] = val.split('/').map(Number)
      const dob = new Date(y, m - 1, d)
      const today = new Date()

      let age = today.getFullYear() - dob.getFullYear()
      const monthDiff = today.getMonth() - dob.getMonth()

      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
        age -= 1
      }
      return age
    },

    isValidEmail (email) {
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      return emailPattern.test(email)
    }
  },

  watch: {
    ktpFile(newValue, oldValue) {
      if (newValue && !oldValue) {
        const isPDF = newValue.type.includes('pdf')
        if(!isPDF) return
        this.$store.commit('showGlobalAlert', {
          message: 'Lengkapi data sesuai KTP kamu',
        })
      }
    }
  },

  async mounted () {
    this.isLoad = true

    try {
      await this.$store.dispatch('getProfile')

      if (this.$store.state.profile) {
        this.alertFailed('Anda sudah terdaftar sebagai Member')
        this.$router.push('/dashboard')
        return
      }
    } catch (err) {
      this.logger('Profile not found')
    }

    // Load all master data
    await Promise.all([
      this.selectProv(),
      this.getJobList(),
      this.listStatus(),
    ])

    this.isLoad = false
  }
}
</script>

<style scoped>
.terms {
  font-weight: 800;
  color: #465F97;
  cursor: pointer;
}
.form-title {
  font-weight: 600;
  font-size: 18px;
  color: #465F97;
  margin-bottom: -4px;
}

.domisili {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-registrasi {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding-top: 20px;
}

.form-input {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.divider {
  height: 1px;
  width: 100%;
  background: #DADCE3;
}

.register-page {
  display: flex;
  height: 100vh;
  background: #f2f4f7;
  overflow: hidden;
}

.reg-container {
  display: block;
  padding: 12px;
  background: white;
  height: 100vh;
  flex-shrink: 0;
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 60px 100px;
  background: #fff;
  height: 100vh;
  overflow-y: auto;
}

.subtitle {
  color: #667085;
  margin-bottom: 24px;
}

.next-btn {
  margin-top: 24px;
  width: 100%;
  padding: 14px;
  border-radius: 10px;
  border: none;
  background: #4c66a4;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease;
  height: 50px;
}

.next-btn:hover:not(:disabled) {
  background: #3d5489;
}

.next-btn:disabled {
  background: #e4e7ec;
  color: #98a2b3;
  cursor: not-allowed;
}

.loader-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.loader {
  width: 16px;
  height: 16px;
  border: 2px solid #ffffff;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.mobile-back {
  text-decoration: none;
  cursor: pointer;
  color: #14264D;
}

/* RESPONSIVE */
.desktop-only {
  display: block;
  height: 100%;
}

.tc-desktop-only {
  display: flex;
  width: 100%;
  margin-top: 8px;
  flex-direction: column;
  gap: 12px;
}

.mobile-only {
  display: none;
}

.tc-mobile-only {
  display: none;
}

.div-desktop-only {
  display: block;
  margin-top: 24px;
  margin-bottom: 24px;
}

.logo {
  align-self: flex-end;
  margin-bottom: 16px;
}


@media (max-width: 1180px) {
  .register-page {
    flex-direction: column;
  }

  .desktop-only {
    display: none;
  }

  .logo {
    align-self: flex-start;
    margin-bottom: 8px;
  }

  .mobile-only {
    display: block;
    margin-bottom: 16px;
    margin-top: 16px;
    display: flex;
    gap: 8px;
    align-items: center;
    font-weight: 600;
    font-size: 16px;
    color: #14264D;
    cursor: pointer;
  }

  .tc-mobile-only {
    width: 100%;
    display: flex;
    margin-top: 8px;
    flex-direction: column;
    gap: 12px;
  }

  .tc-desktop-only {
    display: none;
  }

  .reg-container {
    display: none;
  }

  .content {
    padding: 16px;
  }

  .form-input {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
</style>
